import React from 'react';
import styled from 'styled-components';
import CkoLogo from '../../../assets/cko/CkoLogo';
const Wrapper = styled.div `
  width: ${({ width }) => `${width}px`};
  text-align: center;
`;
export const Logo = ({ width = 125 }) => (React.createElement(Wrapper, { width: width },
    React.createElement(CkoLogo, null)));
